import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const UserService = {
    validateUser: async () => {
        return await axios.get(API_URL + "/validate-user")
            .then(() => ({authenticated: true, message: null}))
            .catch((error) => {
                if (error.response?.status === 401) {
                    return {
                        authenticated: false,
                        message: error.response?.data?.message ?? "Sua sessão não é mais válida. Faça login novamente.",
                    };
                }

                throw error;
            })
    },
    isPrivate: async () => {
        return await axios.get(API_URL + "/is-private")
            .then(({data}) => data)
            .catch(() => false)
    },
    login: async (model) => {
        return await axios.post(API_URL + "/login", model)
            .then(({data}) => data)
            .catch((err) => {
                throw err;
            })
    },
    list: async () => axios.get(API_URL + "/users/list").then(({data}) => data).catch((err) => { throw err }),
    options: async () => axios.get(API_URL + "/users/options").then(({data}) => data).catch((err) => { throw err }),
    create: async (model) => axios.post(API_URL + "/users", model).then(({data}) => data).catch((err) => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/users/" + id, model).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_URL + "/users/" + id).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(API_URL + "/users/" + id).then(({data}) => data).catch((err) => { throw err }),
    updatePassword: async (model) => axios.post(API_URL + "/my-user/updatePassword", model).then(({data}) => data).catch((err) => { throw err }),
    logout: async () => axios.get(API_URL + "/logout").then().catch((err) => { throw err }),

    getResponsibles: async () => axios.get(API_URL + "/users/get/responsibles").then(({data}) => data).catch((err) => { throw err }),
    getRequesters: async (projectId) => axios.get(API_URL + "/users/options/requesters/" + projectId).then(({data}) => data).catch((err) => { throw err }),
    getUserByProject: async (projectId) => axios.get(API_URL + "/users/options/by-project/" + projectId).then(({data}) => data).catch((err) => { throw err }),
    getMultiRequesters: async (data) => axios.post(API_URL + "/users/options/multi/requesters", data).then(({data}) => data).catch((err) => { throw err }),
    getCommercialUsers: async () => axios.get(API_URL + "/users/get/commercials").then(({data}) => data).catch((err) => { throw err }),
}

export default UserService;
